import { ChannelAccount, Entity } from "../../../../types";
import { getCSRFToken } from "../../../utils/various";

export default async function findEntitiesInfo(
  name: string,
  channelAccount: ChannelAccount
): Promise<{
  error?: string;
  entities?: {
    mentions: Entity[];
  };
}> {
  const params = new URLSearchParams({ name });
  const response = await fetch(
    `/channel_accounts/${channelAccount.id}/find_channel_entities?${params}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRFToken(),
      },
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
}
